import { ChakraStylesConfig } from 'chakra-react-select'
import { RemunerationRange } from 'containers/jobs-board/components/options'
import { currencyIds, withSymbol } from 'entities/currency'
import { AllRemunerationTimePeriods } from 'entities/job'

export type RemunerationRangeOption = {
  max: number
  min: number
  label: string
  value: string
}

export const currencySelectChakraStyles: ChakraStylesConfig<any> = {
  menuList: (provided) => {
    return {
      ...provided,
      minW: 'auto',
    }
  },
  dropdownIndicator: (provided) => {
    return {
      ...provided,
      width: '5px',
    }
  },
}

export const createRemunerationRangeOption = ({
  max,
  min,
  currency,
}: {
  max: number
  min: number
  currency: string
}): RemunerationRangeOption => ({
  min,
  max,
  value: currency,
  label: `${withSymbol(currency)}`
})

export const getAvailableRemunerationRangeOptions = (ranges?: RemunerationRange[]) => {
  return (ranges || [])
    .filter(range => range.timePeriod === AllRemunerationTimePeriods.Yearly)
    .map(createRemunerationRangeOption)
    .sort((a, b) => {
      return currencyIds.indexOf(a.value) - currencyIds.indexOf(b.value)
    })
}

export const getRemunerationRangeOption = (
  ranges: RemunerationRange[],
  { currency, timePeriod }: Pick<RemunerationRange, 'currency' | 'timePeriod'>,
): RemunerationRangeOption | undefined => {
  const range = ranges?.find(
    range => range.currency === currency && range.timePeriod === timePeriod,
  )

  return range ? createRemunerationRangeOption(range) : undefined
}
